<div class="cibil-app-page" *ngIf="CibilData; else loadingOrNoData">
  <app-quickloan-cibil-report [cibilResponse]="CibilData"></app-quickloan-cibil-report>
</div>

<ng-template #loadingOrNoData>
  <div class="p-5 text-center my-5" *ngIf="showSpinner">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading CIBIL Report...</span>
    </div>
    <p class="text-muted mt-3 font-weight-bold">Fetching TransUnion CIBIL Report...</p>
  </div>
  <div class="p-5 text-center my-5" *ngIf="!showSpinner && !CibilData">
    <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
    <h5>No CIBIL Report Found</h5>
    <p class="text-muted fs-12">No record exists for the provided Loan/Customer reference.</p>
  </div>
</ng-template>